import styleInject from '../common/temp/pnpm_store/.pnpm/style-inject@0.3.0/pnpm_store/style-inject/dist/style-inject.es.js';

var css_248z = "* {\n  margin: 0;\n  padding: 0;\n}\nhtml {\n  height: 100%;\n}\nbody {\n  margin: 0;\n  font-size: 13px;\n  color: black;\n  font-weight: normal;\n  height: 100%;\n  overflow: hidden;\n  -webkit-text-size-adjust: 100%;\n}\n:focus {\n  outline: none;\n}\n";
styleInject(css_248z);
//# sourceMappingURL=global.less.js.map
